import {
    Globe,
    Facebook,
    Instagram,
    Linkedin,
    AtSign,
    Music2,
    Cloud,
    MapPin,
    Image as ImageIcon,
} from "lucide-react";

export const PLATFORM_ICONS = {
    website: Globe,
    facebook: Facebook,
    instagram: Instagram,
    threads: AtSign,
    linkedin: Linkedin,
    tiktok: Music2,
    bluesky: Cloud,
    google_business: MapPin,
    pinterest: ImageIcon,
};

export const PLATFORM_ACCENTS = {
    website: "text-sky-400",
    facebook: "text-blue-400",
    instagram: "text-pink-400",
    threads: "text-amber-100",
    linkedin: "text-sky-400",
    tiktok: "text-teal-300",
    bluesky: "text-sky-300",
    google_business: "text-emerald-300",
    pinterest: "text-red-400",
};

export function platformIcon(key) {
    return PLATFORM_ICONS[key] || Globe;
}
